import { Grid, Button, Typography, Box, IconButton } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";

import {
  //  changeImageCountAndSave,
  VideTypeImageAndSave,
} from "../../store/slice/gestionImageSlice";
import ImageGallreyPanier from "../../composant/imageGallery/ImagegalleryPanier";
import { ImportButton } from "../../composant/UploadFiles";
import ConfirmationDelete from "../../composant/message/ConfirmationDelete";
import BarUploadProduct from "../../composant/bar/BarUploadProduct";
import BottomBar from "../../composant/navbar/ButtomBar";
import AddIcon from "@mui/icons-material/Add";
import { ReactComponent as DeleteIcon } from "../../image/icons/delete.svg";

const Panier = () => {
  const [ImageType, setImageType] = useState("");
  const ImagePopup = useSelector(
    (state) => state.gestionImage.allImages[ImageType]
  );
  const [AfficherImage, SetAfficherImage] = useState(false);
  const photos = useSelector((state) => state.gestionImage.allImages);

  const { Produits } = useSelector((state) => state.dataApp);
  const photoTypes = Object.keys(photos).filter(
    (key) => photos[key].length > 0
  );
  const dispatch = useDispatch();

  const [deletePopup, setDeletePopup] = useState(false);
  const [TypeDelete, setTypeDelete] = useState("");
  /*
  const [selectedOption, setSelectedOption] = useState("inStore");
  const handleSelect = (option) => {
    setSelectedOption(selectedOption === option ? "delivery" : option);
  };*/
  const navigate = useNavigate();

  function PriceProductByCounter(prix, photoType) {
    let prixFinal = 0;
    const count = photos[photoType].reduce(
      (total, p) => total + (p.count || 0),
      0
    );
    if (count >= 30) {
      prixFinal = prix * 0.6;
    } else if (count >= 10) {
      prixFinal = prix * 0.8;
    } else {
      prixFinal = prix;
    }
    return prixFinal;
  }
  console.log("produits  :", Produits);
  console.log("photoTypes", photoTypes);
  console.log("photos :", photos);
  return (
    <>
      <div style={{ background: "#f7f7f7", minHeight: "100vh" }}>
        <Box>
          <BarUploadProduct
            titre="Ma Commande"
            sousTitre="Panier"
            beforeOnClik={() => {
              navigate(-1);
            }}
          />
          <Grid container spacing={2} sx={{ marginTop: "20px" }}>
            {photoTypes.map((photoType, index) => {
              const produit = Produits.find((p) => p.NomProduit === photoType);
              console.log("produits  :", Produits);
              console.log("photoType :", photoType);

              return (
                <Grid item xs={12}>
                  <Box
                    sx={{
                      background: "#E63D57",
                      borderRadius: "20px",
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <Box
                      sx={{
                        padding: "2%",
                        background: "white",
                        borderRadius: "20px",
                        width: "90%",
                      }}
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={5}>
                          {" "}
                          <img
                            src={produit?.PanierImage}
                            style={{
                              maxHeight: "100px",
                              maxWidth: "100px",
                              height: "auto",
                              width: "auto",
                              borderRadius: "12px",
                            }}
                            alt={photoType}
                          />
                        </Grid>
                        <Grid item xs={5}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",

                              height: "100%",
                              width: "100%",
                            }}
                          >
                            <Typography
                              sx={{
                                fontFamily: "F37 Ginger, sans-serif",
                                fontWeight: 400, 
                                fontStyle: "normal",
                                fontSize: "14px",
                                lineHeight: "100%", 
                                letterSpacing: "0",
                                verticalAlign: "middle",
                                color: "#32324D",
                              }}
                            >
                              Tirage {photoType}
                            </Typography>
                            <br />
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              {/* Prix */}
                              <Typography
                                component="span"
                                sx={{
                                  fontFamily: "Montserrat, sans-serif",
                                  fontWeight: 700,
                                  fontStyle: "normal",
                                  fontSize: "14px",
                                  lineHeight: "100%",
                                  letterSpacing: 0,
                                  verticalAlign: "middle",
                                  color: "#E63D57",
                                }}
                              >
                                {produit?.promoCount
                                  ? PriceProductByCounter(
                                      produit?.prix,
                                      photoType
                                    )
                                  : produit?.prix}
                              </Typography>

                              <Typography
                                component="span"
                                sx={{
                                  fontFamily: "Montserrat, sans-serif",
                                  fontWeight: 700,
                                  fontSize: "8px",
                                  lineHeight: "15px",
                                  verticalAlign: "middle",
                                  color: "#E63D57",
                                }}
                              >
                                Dhs
                              </Typography>

                              <Typography
                                component="span"
                                sx={{
                                  fontFamily: "Montserrat, sans-serif",
                                  fontWeight: 700,
                                  fontStyle: "normal",
                                  fontSize: "14px",
                                  lineHeight: "20px",
                                  letterSpacing: 0,
                                  verticalAlign: "middle",
                                  color: "#E63D57",
                                }}
                              >
                                X{" "}
                                {photos[photoType]
                                  ? photos[photoType].reduce(
                                      (total, p) => total + (p.count || 0),
                                      0
                                    )
                                  : 0}
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
                        <Grid item xs={2}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",

                              height: "100%",
                              width: "100%",
                            }}
                          >
                            <IconButton
                              onClick={() => {
                                setImageType(photoType);
                                SetAfficherImage(true);
                              }}
                            >
                              <VisibilityIcon
                                fontSize="24"
                                sx={{ color: "#E63D57" }}
                              />
                            </IconButton>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                    <IconButton
                      onClick={() => {
                        setTypeDelete(photoType);
                        setDeletePopup(true);
                      }}
                      sx={{ color: "white" }}
                    >
                      <DeleteIcon style={{ width: 24, height: 24 }} />
                    </IconButton>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              position: "fixed",
              bottom: "10%",
              left: "50%",
              transform: "translateX(-50%)",
              width: "90%",
            }}
          >
            <Button
              onClick={() => navigate("/")}
              sx={{
                borderRadius: "16px",
                height: "50px",
                zIndex: 10,
                padding: "2%",
                fontFamily: "Mulish, sans-serif",
                textTransform: "none",
                borderColor: "#E9535D",
                color: "#E9535D",
                backgroundColor: "white",
                "&:hover": {
                  backgroundColor: "#E9535D",
                  color: "white",
                  borderColor: "#E9535D",
                },
                marginBottom: "2%",
              }}
              variant="outlined"
              startIcon={<AddIcon />}
            >
              Ajouter des Produits
            </Button>

            <ImportButton onClick={() => navigate("/commande/inStore")}>
              Passer ma commande
            </ImportButton>
          </Box>
          <BottomBar />

          {/*  <Container
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "100vh",
              padding: 0,
              marginTop: "50px",
              "@media (max-width: 600px)": {
                padding: "10px",
              },
            }}
          >
        photoTypes.length > 0 ? (
              <>
                <Box
                  sx={{ display: { xs: "none", md: "flex", width: "100%" } }}
                >
                  <PanierPc
                    Produits={Produits}
                    photoTypes={photoTypes}
                    photos={photos}
                    handleSelect={handleSelect}
                    selectedOption={selectedOption}
                    setSelectedOption={setSelectedOption}
                    setImageType={setImageType}
                    SetAfficherImage={SetAfficherImage}
                    setDeletePopup={setDeletePopup}
                    setTypeDelete={setTypeDelete}
                  />
                </Box>
                <Box sx={{ display: { xs: "flex", md: "none" } }}>
                  <PanierTele
                    Produits={Produits}
                    photoTypes={photoTypes}
                    photos={photos}
                    handleSelect={handleSelect}
                    selectedOption={selectedOption}
                    setSelectedOption={setSelectedOption}
                    setImageType={setImageType}
                    SetAfficherImage={SetAfficherImage}
                    setDeletePopup={setDeletePopup}
                    setTypeDelete={setTypeDelete}
                  />
                </Box>
                <ImageGallreyPanier
                  open={AfficherImage}
                  images={ImagePopup}
                  handleClose={() => SetAfficherImage(false)}
                  type={ImageType}
                />
              </>
            ) : (
              <Paper>
                <Typography
                  sx={{
                    fontSize: {
                      xs: "24px",
                      md: "36px",
                      lg: "48px",
                      xl: "60px",
                    },
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                  variant="p"
                  padding="10px"
                  color="gray"
                >
                  Aucune image disponible. Veuillez en télécharger.
                </Typography>
              </Paper>
            )
          </Container>
        
        */}
          <ConfirmationDelete
            open={deletePopup}
            onClose={() => setDeletePopup(false)}
            onConfirme={() => {
              dispatch(VideTypeImageAndSave(TypeDelete));
              setDeletePopup(false);
            }}
          />
          <ImageGallreyPanier
            open={AfficherImage}
            images={ImagePopup}
            handleClose={() => SetAfficherImage(false)}
            type={ImageType}
          />
        </Box>
      </div>
    </>
  );
};

export default Panier;
/*
function PanierPc({
  Produits,
  photoTypes,
  photos,
  handleSelect,
  selectedOption,
  setSelectedOption,

  setImageType,
  SetAfficherImage,
  setTypeDelete,
  setDeletePopup,
}) {
  function getSrc(type) {
    const dataProduit = Produits.find((p) => p.NomProduit === type);
    return dataProduit?.PanierImage;
  }
  return (
    <Box width="100%" textAlign="center">
      <Paper sx={{ width: "100%", borderRadius: "25px", marginTop: "150px" }}>
        <Typography variant="p" padding="10px" fontSize="30px" color="gray">
          Liste et prix de votre commande
        </Typography>
        <List>
          {photoTypes.map((photoType, index) => (
            <ListItem
              key={photoType}
              sx={{
                height: "150px",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: { xs: "start", sm: "center" },
              }}
            >
              <Box
                sx={{
                  height: { xs: "50%", sm: "60%" },
                  marginBottom: { xs: 1, sm: 0 },
                  width: { xs: "100%", sm: "auto" },
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <img
                  src={getSrc(photoType)}
                  style={{
                    maxHeight: "100%",
                    maxWidth: "100%",
                    height: "auto",
                    width: "auto",
                  }}
                  alt={photoType}
                />
              </Box>
              <ListItemText
                sx={{
                  "& .MuiListItemText-primary": {
                    fontSize: { xs: "1.5rem", sm: "2rem" },
                  },
                  marginX: { xs: 1, sm: 0 },
                }}
                primary={`Photo ${
                  photoType.charAt(0).toUpperCase() + photoType.slice(1)
                }`}
              />
              <ListItemSecondaryAction
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  flexDirection: { xs: "column", sm: "row" },
                  marginTop: { xs: 1, sm: 0 },
                }}
              >
                <IconButton
                  onClick={() => {
                    setImageType(photoType);
                    SetAfficherImage(true);
                  }}
                >
                  <Badge badgeContent={photos[photoType].length} color="error">
                    <CollectionsIcon fontSize="large" />
                  </Badge>
                </IconButton>
                <IconButton
                  onClick={() => {
                    setImageType(photoType);
                    SetAfficherImage(true);
                  }}
                >
                  <VisibilityIcon fontSize="large" />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  sx={{ color: "#E9535D" }}
                  onClick={() => {
                    setTypeDelete(photoType);
                    setDeletePopup(true);
                  }}
                >
                  <CancelIcon fontSize="large" />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </Paper>

      <Grid
        container
        sx={{
          width: {
            md: "100%",
          },
        }}
        marginTop="4%"
        spacing={4}
        textAlign="center"
      >
        <Grid item xs={6} md={3}>
          <Button
            variant="contained"
            sx={{
              borderRadius: "10px",
              height: "50px",
              backgroundColor:
                selectedOption === "delivery" ? "#e8555f" : "#002244",
              "&:hover": {
                backgroundColor:
                  selectedOption === "delivery" ? "#e8555f" : "#002244", // hover state
              },
            }}
            color="secondary"
            onClick={() => handleSelect("delivery")}
            startIcon={
              <Checkbox
                sx={{
                  color: "#ffffff",
                  "&.Mui-checked": {
                    color: "#ffffff", // White color when checked
                  },
                }}
                checked={selectedOption === "delivery"}
              />
            }
          >
            Livraison
          </Button>
        </Grid>
        <Grid item xs={6} md={3}>
          <Button
            variant="contained"
            sx={{
              borderRadius: "10px",
              height: "50px",
              backgroundColor:
                selectedOption === "inStore" ? "#e8555f" : "#002244",
              "&:hover": {
                backgroundColor:
                  selectedOption === "inStore" ? "#e8555f" : "#002244", // hover state
              },
            }}
            color="secondary"
            onClick={() => handleSelect("inStore")}
            startIcon={
              <Checkbox
                sx={{
                  color: "#ffffff",
                  "&.Mui-checked": {
                    color: "#ffffff", // White color when checked
                  },
                }}
                checked={selectedOption === "inStore"}
              />
            }
          >
            Retrait en magasin
          </Button>
        </Grid>
        <Grid item xs={12} md={6}>
          <Link to={`/commande/${selectedOption}`}>
            <ImportButton sx={{ width: "80%", height: "100%" }}>
              confirmer
            </ImportButton>
          </Link>
        </Grid>
      </Grid>
    </Box>
  );
}

function PanierTele({
  photoTypes,
  photos,
  handleSelect,
  selectedOption,
  setSelectedOption,

  setImageType,
  SetAfficherImage,
  setTypeDelete,
  setDeletePopup,
}) {
  const styles = {
    paper: {
      margin: "auto",
      padding: "20px",
      width: "100%",
      marginBottom: "60px",
    },
    listItem: {
      width: "100%",
      justifyContent: "space-between",
    },
    button: {
      marginTop: "20px",
      backgroundColor: "#FF1744", // Use the color from your brand palette
      color: "white",
      width: "100%",
      padding: "10px 0",
      textTransform: "none", // If you want to keep the button text as is
    },
    header: {
      marginBottom: "50px",
      fontSize: "25px",
      fontWeight: "bold",
      textAlign: "centre",
    },
  };
  return (
    <Box>
      <Typography style={styles.header}>Ma Commande</Typography>
      <Grid
        container
        spacing={4}
        textAlign="center"
        sx={{ marginBottom: "50px" }}
      >
        <Grid item xs={6} md={3}>
          <Button
            variant="contained"
            sx={{
              height: "50px",
              borderRadius: "10px",
              backgroundColor:
                selectedOption === "delivery" ? "#e8555f" : "#002244",
              "&:hover": {
                backgroundColor:
                  selectedOption === "delivery" ? "#e8555f" : "#002244", // hover state
              },
              fontSize: {
                xs: "12px",
              },
            }}
            color="secondary"
            onClick={() => handleSelect("delivery")}
            startIcon={
              <Checkbox
                sx={{
                  color: "#ffffff",
                  "&.Mui-checked": {
                    color: "#ffffff", // White color when checked
                  },
                }}
                checked={selectedOption === "delivery"}
              />
            }
          >
            Livraison
          </Button>
        </Grid>
        <Grid item xs={6} md={3}>
          <Button
            variant="contained"
            sx={{
              height: "50px",
              borderRadius: "10px",
              backgroundColor:
                selectedOption === "inStore" ? "#e8555f" : "#002244",
              "&:hover": {
                backgroundColor:
                  selectedOption === "inStore" ? "#e8555f" : "#002244", // hover state
              },
              fontSize: {
                xs: "12px",
              },
            }}
            color="secondary"
            onClick={() => handleSelect("inStore")}
            startIcon={
              <Checkbox
                sx={{
                  color: "#ffffff",
                  "&.Mui-checked": {
                    color: "#ffffff", // White color when checked
                  },
                }}
                checked={selectedOption === "inStore"}
              />
            }
          >
            Retrait en magasin
          </Button>
        </Grid>
      </Grid>
      <Paper style={styles.paper} elevation={3}>
        <Typography variant="p" padding="10px" color="gray">
          Liste et prix de votre commande
        </Typography>
        <List component="nav">
          {photoTypes.map((photoType) => (
            <ListItem style={styles.listItem}>
              <ListItemText
                primary={`Photo ${
                  photoType.charAt(0).toUpperCase() + photoType.slice(1)
                }`}
              />
              <Typography variant="body2">
                <IconButton
                  onClick={() => {
                    setImageType(photoType);
                    SetAfficherImage(true);
                  }}
                >
                  <Badge badgeContent={photos[photoType].length} color="error">
                    <CollectionsIcon />
                  </Badge>
                </IconButton>
                <IconButton
                  onClick={() => {
                    setImageType(photoType);
                    SetAfficherImage(true);
                  }}
                >
                  <VisibilityIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  sx={{ color: "#E9535D" }}
                  onClick={() => {
                    setTypeDelete(photoType);
                    setDeletePopup(true);
                  }}
                >
                  <CancelIcon />
                </IconButton>
              </Typography>
            </ListItem>
          ))}
        </List>
      </Paper>
      <Link to={`/commande/${selectedOption}`}>
        <ImportButton sx={{ width: "100%", minHeight: "60px" }}>
          confirmer
        </ImportButton>
      </Link>
      <BottomBar />
    </Box>
  );
}
*/
